import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { ReactComponent as FilterIc } from 'assets/icons/filter.svg';
import { Dropdown } from 'react-bootstrap';

import theme from 'styles/theme';

export const Scrollbar = styled.div`
  height: 87vh;

  ::-webkit-scrollbar-track {
    background-color: #f5f5f5;
  }

  ::-webkit-scrollbar {
    width: 6px;
    background: #f5f5f5;
  }

  ::-webkit-scrollbar-thumb {
    background: #f5f5f5;
  }
`;

export const BoxPadding = styled.div`
  padding: 24px 20px 0;

  @media (max-width: 768px) {
    padding: 16px 16px 0;
  }
`;

export const HeaderPage = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;

  @media (max-width: 992px) {
    .selected-download-message {
      display: none;
    }
  }
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h1`
  margin: 0;
  font-family: 'Mangueira bold', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
  color: #0b29fb;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  color: #3d3d3d;
`;

export const Hr = styled.hr`
  border-color: #c1c1c1;
  border-style: dashed;
  margin: 0 0 20px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;

  @media (max-width: 455px) {
    flex-direction: column;
    justify-content: flex-end;

    & button {
      min-height: 32px;
      max-height: 32px;
      min-width: 100%;
      padding: 2px 8px;
    }

    & button:not(:first-child) {
      margin: 10px 0 0 0;
    }

    #dropdown-mobile-order {
      order: 4;

      #for-mail {
        display: none;
      }
    }
  }
`;

export const FilterButton = styled.button`
  border: none;
  cursor: pointer;
  height: 32px;
  width: auto;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: 0.5s opacity;
  background-color: ${theme.colors.blue};
  color: #fff;
  padding: 4px 12px;
  font-size: 13px;
  justify-content: center;
  margin-left: 10px;

  &:hover {
    opacity: 0.85;
  }

  &:focus {
    box-shadow: none;
  }
`;

export const FilterIcon = styled(FilterIc)`
  margin-left: -5px;
  margin-right: 5px;

  .a {
    fill: none !important;
  }
`;

export const FilterText = styled.p`
  margin-top: 7px;
  margin-bottom: 3px;
`;

export const SortButton = styled.button`
  border: none;
  cursor: pointer;
  height: 32px;
  width: auto;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: 0.5s opacity;
  background-color: ${theme.colors.blue};
  color: #fff;
  padding: 4px 12px;
  font-size: 13px;
  margin-right: 10px;
  justify-content: center;

  &:hover {
    opacity: 0.85;
  }

  &:focus {
    box-shadow: none;
  }

  @media (min-width: 930px) {
    display: none;
  }
`;

export const SortIcon = styled.span`
  font-size: 20px;
  margin-bottom: -2px;
`;

export const ClearButton = styled.button`
  border: none;
  cursor: pointer;
  height: 32px;
  width: auto;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  transition: 0.5s opacity;
  color: ${theme.colors.blue};
  background-color: transparent;
  border: 1px solid ${theme.colors.blue};
  padding: 4px 12px;
  font-size: 13px;
  margin-left: 10px;
  justify-content: center;

  &:hover {
    opacity: 0.85;
  }

  &:focus {
    box-shadow: none;
  }
`;

export const Table = styled.div`
  width: 100%;

  #selected-mobile,
  #text-selected {
    display: none;
  }

  @media (max-width: 930px) {
    #selected-mobile {
      display: inline-block;
      margin-left: 32px;
    }

    #text-selected {
      display: inline-block;
      font-size: 13px;
      font-weight: bold;
      margin-left: -15px;
    }
  }
`;

export const Thead = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  padding: 20px 40px;
  gap: 30px;
  position: sticky;
  top: 0;
  transition: background-color 0.2s;

  @media (max-width: 930px) {
    display: none;
  }

  @media (max-width: 1100px) {
    top: 56px;
  }
`;

type ThProps = {
  local?: boolean;
};

export const Th = styled.div<ThProps>`
  font-size: 14px;
  font-weight: bold;
  color: #464646;
  max-width: ${({ local }) => (local ? '100px' : '100%')};
  overflow: ${({ local }) => (local ? 'hidden' : 'auto')};
  text-overflow: ${({ local }) => (local ? 'ellipsis' : 'initial')};
  white-space: ${({ local }) => (local ? 'nowrap' : 'normal')};
  display: flex;
  align-items: center;
`;

export const Tbody = styled.div`
  margin-top: -20px;
  padding: 20px;
`;

export const SortArrow = styled.i`
  color: #0011ff;
  margin-top: 6px;
  cursor: pointer;
`;

type ListForDownloadProps = {
  isSelected?: boolean;
  selectAllInvoices?: boolean;
  disponibleForDownload?: boolean;
};

export const ListForDownload = styled.div<ListForDownloadProps>`
  > div > div {
    border: 2px solid
      ${({ isSelected, selectAllInvoices }) =>
        isSelected || selectAllInvoices ? theme.colors.blue : '#ffffff'};

    ${({ disponibleForDownload, isSelected, selectAllInvoices }) =>
      !disponibleForDownload &&
      (isSelected || selectAllInvoices) &&
      css`
        opacity: 0.3;
        pointer-events: none;
        border: 2px solid rgba(0, 0, 0, 0.4);
      `}

    padding-left: 43px !important;
    padding: 18px;
  }

  .select_nota {
    min-width: 14px;
    min-height: 14px;
    width: 14px;
    height: 14px;
    border: 2px solid ${theme.colors.blue};
    position: relative;
    margin-left: 20px;
    border-radius: 2px;
    margin-bottom: -45px;
    margin-top: 45px;
  }

  .selected {
    background: ${theme.colors.blue};
  }
`;

const StyledActionsDropdown = styled(Dropdown)`
  button {
    box-shadow: none !important;
    outline: none !important;
  }

  .dropdown-toggle {
    background: ${theme.colors.mediumPurple};
    font-size: 13px;
    font-weight: 400;
    letter-spacing: 0;
    height: 32px;
    padding: 0 10px;
    border-radius: 4px;

    @media (max-width: 456px) {
      margin: 10px 0 0 0;
    }
  }

  .dropdown-item {
    font-size: 14px;
  }

  .mdi {
    margin-right: 7px;
    opacity: 0.7;
  }

  .dropdown-item:focus,
  .dropdown-item:hover {
    background-color: #ffffff;
    color: ${theme.colors.mediumPurple};
  }
`;

export const ActionsButton = Object.assign(StyledActionsDropdown, {
  Toggle: Dropdown.Toggle,
  Menu: Dropdown.Menu,
  Item: Dropdown.Item,
});

export const DropdownSeparator = styled.div`
  border-bottom: 1px dashed #c9c9c9;
  margin: 7px 14px;
`;

type SelectedItemProps = {
  selectAllInvoices?: boolean;
  marginThead?: boolean;
};

export const SelectedItem = styled.div<SelectedItemProps>`
  min-width: 14px;
  min-height: 14px;
  border: 2px solid ${theme.colors.blue};
  position: relative;
  margin-right: 20px;
  margin-left: -20px;
  border-radius: 2px;
  background: ${({ selectAllInvoices }) =>
    selectAllInvoices ? theme.colors.blue : '#ffffff'};
  margin-left: ${({ marginThead }) => (marginThead ? '3px' : '-20px')};
  margin-right: ${({ marginThead }) => (marginThead ? '20px' : '10px')};
  margin-top: ${({ marginThead }) => (marginThead ? '3px' : '0')};
  cursor: pointer;
`;

export const SelectedText = styled.span`
  margin-top: 7px;
  color: #0011ff;
`;

export const EmptyMessage = styled.p`
  margin-left: 20px;
  font-size: 18px;
`;
